/**
 * This will notify Bugsnag of our caught exception using
 * the specified options. The only requirement is that the
 * options object contains the caught Error.
 *
 * @param {Object} options {
 *   {Error} error - This is the error object that caused the issue
 *
 *   {String} errorName - This is the error name to provide context
 *                        to whoever is looking in the Bugsnag app
 *
 *   {Object} meta - This is an object whose attributes will be
 *                   included in the `META` tab within Bugsnag.
 *                   By default this will include the response status,
 *                   statusText, and request URL.
 * }
 */
export function notifyException(options) {
  const {errorName, error, meta = {}, response = {}} = options;

  if (!error || !window.Bugsnag) {
    return;
  }

  const _meta = {
    meta: {
      responseStatus: response.status,
      responseStatusText: response.statusText,
      requestUrl: response.url,
      ...meta,
    },
  };

  window.Bugsnag.notifyException(error, errorName, _meta);
}
